import React, {useRef, useState} from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import SwiperCore, {Navigation} from 'swiper';
import {Typography} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import 'components/Shared/MySwiper.scss';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';

SwiperCore.use([Navigation]);

const MySwiper = ({list, params, titleHeader, children = null}) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiper, setSwiper] = useState();

  return (
    <div className="my-swiper-wrapper">
      {titleHeader && (
        <div className="SC-header">
          <Typography noWrap variant="h5" className="grille-titre" align="left">
            {titleHeader}
          </Typography>
          {children && children}
          <div className="MLC-header-arrows">
            <Button onClick={() => swiper.slidePrev()}>
              <ArrowBackIcon />
            </Button>
            <Button onClick={() => swiper.slideNext()}>
              <ArrowForwardIcon />
            </Button>
          </div>
          {/* <div className="SCH-arrows-container">
            <div className="gg-arrow-left" onClick={() => swiper.slidePrev()}></div>
            <div className="gg-arrow-left right" onClick={() => swiper.slideNext()}></div>
          </div> */}
        </div>
      )}
      <Swiper
        {...params}
        onSwiper={swiper => setSwiper(swiper)}
        navigation={{
          nextEl: nextRef.current,
          prevEl: prevRef.current,
        }}
      >
        {list.map((item, index) => (
          <SwiperSlide key={index}>{item}</SwiperSlide>
        ))}
      </Swiper>
      {list.length > params.slidesPerView && (
        <>
          <div ref={nextRef} className="swiper-button-next"></div>
          <div ref={prevRef} className="swiper-button-prev"></div>
        </>
      )}
    </div>
  );
};

export default MySwiper;
